/* BETALUMINA_PUSH_CONTROL_V1 */
import { useEffect, useState } from "react";
import { FaBell, FaCheckCircle, FaBan } from "react-icons/fa";
import { toast } from "react-toastify";
import { ensurePushSubscription, isPushSupported } from "../services/pushNotifications";
import "./PushNotificationControl.css";

const PushNotificationControl = () => {
  const [status, setStatus] = useState("checking");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!isPushSupported()) {
        if (!cancelled) setStatus("unsupported");
        return;
      }
      try {
        const result = await ensurePushSubscription({ askPermission: false });
        if (!cancelled) setStatus(result.status);
      } catch (error) {
        console.error("Errore stato notifiche:", error);
        if (!cancelled) setStatus("error");
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const enable = async () => {
    if (busy || status === "enabled") return;
    setBusy(true);
    try {
      const result = await ensurePushSubscription({ askPermission: true });
      setStatus(result.status);
      if (result.status === "enabled") {
        toast.success("Notifiche nuovi interventi attivate.");
      } else if (result.status === "denied") {
        toast.info("Notifiche bloccate dal browser. Abilitale nelle autorizzazioni del sito.");
      }
    } catch (error) {
      console.error("Errore attivazione notifiche:", error);
      setStatus("error");
      toast.error("Impossibile attivare le notifiche.");
    } finally {
      setBusy(false);
    }
  };

  if (status === "unsupported") return null;

  if (status === "enabled") {
    return (
      <button type="button" className="push-notification-control is-enabled" disabled
        title="Notifiche nuovi interventi attive su questo dispositivo">
        <FaCheckCircle aria-hidden="true" /><span>Notifiche attive</span>
      </button>
    );
  }

  if (status === "denied") {
    return (
      <button type="button" className="push-notification-control is-denied" disabled
        title="Notifiche bloccate: abilitarle dalle autorizzazioni del sito">
        <FaBan aria-hidden="true" /><span>Notifiche bloccate</span>
      </button>
    );
  }

  return (
    <button type="button" className="push-notification-control" onClick={enable}
      disabled={busy || status === "checking"}
      title="Attiva le notifiche Android per i nuovi interventi">
      <FaBell aria-hidden="true" />
      <span>{busy ? "Attivazione..." : status === "checking" ? "Notifiche..." : "Attiva notifiche"}</span>
    </button>
  );
};

export default PushNotificationControl;
